'use client';

import React, { useState, useRef } from 'react';
import { useGTM } from '@/features/Analytics';
import { Slider } from '@/widgets/Slider';
import { useElementScroll } from '@/shared/hooks/dom/scroll/useElementScroll';
import { useImageIntersectionObserver } from '../hooks/useImageIntersectionObserver';
import { GalleryThumbnail } from './GalleryThumbnail';
import { ImageViewer } from './ImageViewer';
import type { ImageGalleryProps } from '../model/types';
export const ImageGallery: React.FC<ImageGalleryProps> = ({
  pageType,
  images,
  className = '',
  clickvEventName
}) => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const {
    trackEvent
  } = useGTM(pageType);
  const {
    imageRefs,
    visibleImages
  } = useImageIntersectionObserver(sliderRef);
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const {
    scrollToElement
  } = useElementScroll(sliderRef);
  const handleImageClick = (index: number): void => {
    trackEvent(clickvEventName || '');
    setSelectedImageIndex(index);
    scrollToElement(index);
  };
  const handleClose = () => {
    setSelectedImageIndex(null);
  };
  const handleNavigate = (index: number) => {
    setSelectedImageIndex(index);
    scrollToElement(index);
  };
  const shouldLoadImage = (index: number): boolean => {
    return visibleImages[index] || visibleImages[index - 1] || visibleImages[index + 1] || index < 2;
  };
  return <>
      <div className={`mx-auto w-full max-w-6xl ${className}`}>
        <Slider ref={sliderRef} data-sentry-element="Slider" data-sentry-source-file="index.tsx">
          {images.map((image, index) => <GalleryThumbnail key={index} ref={el => {
          imageRefs.current[index] = el;
        }} index={index} image={image} shouldLoad={shouldLoadImage(index)} onClick={handleImageClick} imagesLength={images.length} />)}
        </Slider>
      </div>

      {typeof selectedImageIndex === 'number' && <ImageViewer images={images} selectedIndex={selectedImageIndex} onClose={handleClose} onNavigate={handleNavigate} />}
    </>;
};